import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

const withRouter = (Component) => {
  const ComponentWithRouterProp = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    //Update navigation state data with query params.
    const updateNavigationData = (newStateData) => {
      const search = location.search;
      navigate(search, {
        replace: true,
        state: { ...location.state, ...newStateData },
      });
    };
    return <Component {...props} router={{ location, navigate, searchParams, updateNavigationData }} />;
  };

  return ComponentWithRouterProp;
};

export default withRouter;
